// @flow
import React from 'react';
import type { ComponentType } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Typography from '@material-ui/core/Typography';

import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Clear';
import { withStyles } from '@material-ui/core/styles';
import { removeDialog } from 'data/rootUi/actions';

import { styles } from './styles';
import { DIALOG_CLOSE_EVENTS } from './types';

export const isDialogCloseAction = (actionEvent: string) => DIALOG_CLOSE_EVENTS.find((event) => event === actionEvent);

type Props = {
  colorBar: ?string,
  dialogId: string,
  dialogProps: Object,
  disableTitleTypography : boolean,
  showCloseButton: boolean,
  spacedButton: boolean,
  title: string,
  wrappedDialog: any,

  onClose: () => void,
  removeDialog: (?string) => void,

  renderActions: () => void;
  // from withStyles
  classes: Object,
}

type State = {
  open: boolean,
}

export default () => (WrappedDialog: ComponentType<any>): ComponentType<any> => {
  class StdDialog extends React.PureComponent<Props, State> {

    wrappedDialog: any;

    static defaultProps = {
      showCloseButton: false,
    };

    constructor(props) {
      super(props);
      this.state = { open: true };
    }

    closeDialog = () => {
      this.setState({ open: false });
      setTimeout(() => this.props.removeDialog(this.props.dialogId), 2000);
    };

    handleClose = (event: ?Event = null, reason: string) => {
      let localReason = reason;
      if (!localReason || localReason === 'backdropClick') {
        localReason = 'BACKDROP_CLICK';
      }

      if (this.wrappedDialog.handleClose) {
        this.wrappedDialog.handleClose(event, localReason);
      } else {
        this.closeDialog();
      }
    };

    renderCloseButton = () => {
      const { classes, showCloseButton, spacedButton } = this.props;
      if (showCloseButton) {
        return (
          <IconButton
            className={classNames(classes.closeButton, spacedButton && classes.spacedButton)}
            style={{ color: this.props.colorBar ? '#ffffff' : ''}}
            aria-label="Close"
            id="dlg-close"
            onClick={(event) => this.handleClose(event, 'CLOSE_BUTTON')}
          >
            <CloseIcon />
          </IconButton>
        );
      }
      return null;
    };

    renderTitle = () => {
      const { classes, disableTitleTypography, title } = this.props;
      if (title) {
        if (disableTitleTypography) {
          return title;
        }
        return (
          <Typography
            className={classes.title}
            variant="h5"
            id="dialog-title"
          >
            {this.props.title}
          </Typography>
        );
      }
      return null;
    };

    render() {
      const { dialogProps, classes, renderActions, ...other } = this.props;
      return (
        <Dialog
          open={this.state.open}
          {...dialogProps}
          onClose={(event, reason) => this.handleClose(event, reason)}
          aria-labelledby="dialog-title"
        >
          {this.renderCloseButton()}
          {this.renderTitle()}
          <WrappedDialog
            {...other}
            closeDialog={this.closeDialog}
            onRef={(ref) => {
              this.wrappedDialog = ref;
            }}
          />
          {renderActions && renderActions({handleClose: this.handleClose})}
        </Dialog>
      );
    }
  }

  function mapDispatchToProps(dispatch) {
    return {
      removeDialog: (props) => dispatch(removeDialog(props)),
    };
  }

  return compose(
    withStyles(styles, { name: 'StdDialog' }),
    connect(null, mapDispatchToProps, null),
  )(StdDialog);

};


